import Sticker from '@@types/Sticker';

import { EMOJI_CATEGORY } from '~/components/UiKit/emoji-selector/EmojiSelector.constant';
import { Emoticon, STICKER_PAGE_COUNT } from '~/constants';
import EmoticonPopperState from '~/services/EmoticonPopperState';
import { mainDetailUiState, threadDetailUiState } from '~/stores/DetailUiState';
import pageUtil from '~/utils/pageUtil';
import { action, computed, observable } from 'mobx';

class EmoticonStickerStore {
  @observable stickers: Sticker[] = [];

  public emoticonTabs = Object.keys(EMOJI_CATEGORY);

  public reset = (type: Emoticon) => {
    this.setPage(0);
    this.setActiveIndex(-1);
    this.setTab(type === Emoticon.Sticker ? this.stickers[0]?.id : this.emoticonTabs[0]);
  };

  @action
  setStickersFromRes = (stickers: Sticker[]) => {
    this.stickers = stickers;
  };

  @computed
  get isOpenedMain() {
    return !!mainDetailUiState.activeEmoticonState;
  }

  @computed
  get totalPage() {
    return pageUtil.calcLastPage(this.stickers.length, STICKER_PAGE_COUNT);
  }

  @computed
  get activePopperState(): EmoticonPopperState | null {
    return mainDetailUiState.activeEmoticonState ?? threadDetailUiState.activeEmoticonState;
  }

  @observable
  tab = '';

  @action
  setTab = (tab: string) => {
    this.tab = tab;
  };

  @observable
  page = 0;

  @action
  setPage = (page: number) => {
    this.page = page;
  };

  @observable
  activeIndex = -1;

  @action
  setActiveIndex = (index: number) => {
    this.activeIndex = index;
  };
}

export default EmoticonStickerStore;

export const emoticonStickerStore = new EmoticonStickerStore();
